import React from "react";
import '../css/keyBoardInstruction.css';

export default class KeyBoardInstruction extends React.Component {
  render() {
      var elements;
      if(this.props.Keys.length === 1){
          elements = <div
          className="internalDiv"
        ><div className="kpd">{this.props.Keys[0]}</div></div>;
      }else if(this.props.Keys.length === 2){
        elements = <div
        className="internalDiv"
      ><div className="kpd">{this.props.Keys[0]}</div>+<div className="kpd">{this.props.Keys[1]}</div></div>
      }
    return (
      <div>
        <div className="InstructionContainer">  
          {elements}
          <p className="KeyboardInstruction">{this.props.Instruction}</p>
        </div>
      </div>
    );
  }
}